import React from "react";
import Navbarrr from "../navbar/navbarrr";
import "./short.css";
import Card from "react-bootstrap/Card";
import Footer from "../navbar/footer";

function Short() {
  return (
    <div className="gsfgshjhub">
      <Navbarrr />
      <div className="shrrtttt">
        <h1 className="h2shrt">Short Courses at NLSA </h1>
        <div className="displyshrtt">
          <img alt="new" src="images/logo.png" className="imgshrt"></img>
        </div>
      </div>
      <div className="shrtttsimg">
        <img
          alt="abc"
          src="images/shortcourse.jpg"
          className="imgshttrtrtr"
        ></img>
      </div>
      <div>
        <>
          <Card>
            <Card.Img
              variant="top"
              src="https://static.sliit.lk/wp-content/uploads/2019/08/02034506/Certificate-Program-in-Microsoft-Office.jpg"
            />
            <Card.Body>
              <h2 style={{ textAlign: "center" }}>1. Foundation Basic</h2>
            </Card.Body>
          </Card>
          <br />
          <Card>
            <Card.Body>
              <h2 style={{ textAlign: "center" }}>2. Graphic Designing</h2>
            </Card.Body>
            <Card.Img
              variant="bottom"
              src="https://www.cdmi.in/courses@2x/graphics-design-training-institute.jpg"
            />
          </Card>
        </>
      </div>
      <div>
        <h2 className="hhhhh333short"> MEET THE TEACHERS</h2>
        <div className="tchersshort">
          <Card style={{ width: "22rem" }}>
            <Card.Img variant="top" src="images/teacher4.jpg" />
            <Card.Body>
              <p className="tchrtxtshort">
                Sir Ikram Akram
                <br />
                BSCS Cont <br />
                NCBA&E
              </p>
            </Card.Body>
          </Card>

          <Card style={{ width: "22rem" }}>
            <Card.Img variant="top" src="images/Hassan.jpg" />
            <Card.Body>
              <p className="tchrtxtshort">
                Sir Hassan Shahbaz
                <br />
                Graphic Designer at News Channel, <br />
                Software House
                <br /> 3D Animator Course at Maqsad Anim School{" "}
              </p>
            </Card.Body>
          </Card>
        </div>
        <div className="tchersshort">
          <Card style={{ width: "22rem" }}>
            <Card.Img variant="top" src="images/usama.jpg" />
            <Card.Body>
              <p className="tchrtxtshort">
                Sir Usama Ahmad
                <br />
                BSCS
                <br /> Lahore Garrison University{" "}
              </p>
            </Card.Body>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Short;
